import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import Button from '../Shared/Button'

class AddonsListItem extends Component {
  getDetailsURL = () => {
    const { match, item } = this.props
    const { appId } = match.params

    return `/apps/${appId}/addons/${item.id}`
  }

  getInstallURL = () => {
    const { match, item } = this.props
    const { appId } = match.params

    return `/apps/${appId}/addons/install/${item.id}`
  }

  render() {
    const { item } = this.props
    const { name, tagline } = item

    return (
      <div className="addons-list-item">
        <h3>{name}</h3>
        <p className="addons-list-item-tagline">{tagline}</p>
        <div className="addons-list-item-actions">
          <Button secondary to={this.getDetailsURL()}>
            Details
          </Button>
          <Button to={this.getInstallURL()}>Install</Button>
        </div>
      </div>
    )
  }
}

export default withRouter(AddonsListItem)
